import {PageWrapper, TranslationTypography} from "../../components";

export default function AboutPage () {

  return(
      <PageWrapper>
          <TranslationTypography text="About" variant='h3'/>
      </PageWrapper>
  )
}